<template>
  <GridLayout :class="classes" columns="50, *">
    <StackLayout col="0" class="icon-wrapper" verticalAlignment="top">
      <AgIcon set="fas" :type="icon" color="#FFFFFF" :aria-label="iconLabel" />
    </StackLayout>
    <StackLayout col="1" class="text-wrapper">
      <Label v-if="textReal.length" :text="textReal" textWrap="true" />
      <slot name="default"></slot>
    </StackLayout>
  </GridLayout>
</template>

<script>

export default {
  props: {
    text: {
      type: [String, Number, Boolean, Error],
      default: ''
    },
    type: {
      type: String,
      default: 'info'
    },
    noMargin: {}
  },
  computed: {
    classes () {
      let classes = ['notice', 'type-' + this.typeReal]

      if (this.noMargin === 'true' || this.noMargin === '' || this.noMargin === true) classes.push('no-margin')

      return classes.join(' ') 
    },
    typeReal () {
      return ['success', 'warning', 'error'].indexOf(this.type) < 0 ? 'info' : this.type
    },
    textReal () {
      return String(this.text)
    },
    icon () {
      switch (this.typeReal) {
        case 'success':
          return 'checkCircle'
        case 'warning':
          return 'exclamationTriangle'
        case 'error':
          return 'exclamationCircle'
      }

      return 'infoCircle'
    },
    iconLabel () {
      switch (this.typeReal) {
        case 'success':
          return 'Success'
        case 'warning':
          return 'Warning'
        case 'error':
          return 'Error'
      }

      return 'Information'
    }
  },
  methods: {
  }
}

</script>

<style scoped lang="scss">

.notice {
  border-width: 0;
  border-radius: 0;
  background-color: #3598db;
}

.notice.no-margin {
  margin-bottom: 0;
}

.notice .text-wrapper {
  background-color: #FFFFFF;
  color: #3598db;
}

.notice.type-success {
  background-color: #00bc8c;
}

.notice.type-success .text-wrapper {
  color: #00bc8c;
}

.notice.type-warning {
  background-color: #f39c11;
}

.notice.type-warning .text-wrapper {
  color: #f39c11;
}

.notice.type-error {
  background-color: #e84c3d;
}

.notice.type-error .text-wrapper {
  color: #e84c3d;
}

.ns-ios,
.ns-android {
  .notice {
    border-radius: 6;
    padding: 1;
    margin-top: 20;
  }

  .notice .icon-wrapper {
    padding: 16 0 0 0;
  }

  .notice .text-wrapper {
    border-radius: 5;
    padding: 16;
  }
}

html {
  .notice {
    border-radius: 6px;
    border-spacing: 0;
    padding: 2px;
    margin-top: 20px;
  }

  .notice .icon-wrapper {
    padding: 16px 0 0 0;
    vertical-align: top;
  }

  .notice .text-wrapper {
    border-radius: 5px;
    padding: 16px;
  }
}

</style>